module.exports = __webpack_public_path__ + "static/img/important8.573e160.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/important8.png
// module id = q1jw
// module chunks = 1